import * as React from "react";
import { FunctionComponent } from "react";
import "./BackHeader.css";
import LeftArrow from "assets/svg/left-arrow";
import { useHistory } from "react-router-dom";

interface Props {
  title: string;
  onBackClick?: () => void;
}

const BackHeader: FunctionComponent<Props> = (props: Props) => {
  const { title, onBackClick } = props;
  const routerHistory = useHistory();

  const onBackBtnClick = () => {
    if (onBackClick) onBackClick();
    else {
      routerHistory.goBack();
    }
  };

  return (
    <div className="back-header-main-container">
      <div className="arrow-container" onClick={onBackBtnClick}>
        <LeftArrow />
      </div>
      <div className="title-container">{title}</div>
    </div>
  );
};

export default BackHeader;
